import { PixelRatioImage, type PixelRatioImageProps } from "@/components/common/pixel-ratio-image";
import aiSpeechImage from "@/assets/agent-user-detail/ai-speech@3x.webp";

export const AiSpeechImage = (props: Omit<PixelRatioImageProps, "images">) => {
  return (
    <PixelRatioImage
      images={[aiSpeechImage]}
      {...props}
    />
  );
};

AiSpeechImage.displayName = 'AiSpeechImage';
